import type { FaireProductEntity } from "../../entity_types/product";

export const p_zufc3mf49w: FaireProductEntity = {
  token: "p_zufc3mf49w",
  type: "product",
  name: "24 Shower Steamers|Shower Steamer|Bath Bomb||Shower|Bath Bombs|Shower Bombs",
  brandToken: "b_chkchzbnrw",
  brandName: "Subtle & Wild",
  imageUrl:
    "https://cdn.faire.com/fastly/66bbb10068a08d8b43076d8aede1328a3e02d66f08f99576c284b3e1eade0172.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/41503b344758ea674bfae53a1d903f4b62142713f1ca09f94bb9e9d10f3dedd6.jpeg",
    "https://cdn.faire.com/fastly/4b69078907cacb234179779008c2bc40d8f46817e034cf64e8cfeaa430a53c2e.jpeg",
    "https://cdn.faire.com/fastly/f3f4bbca76be30976619c4c084ff62054ea4fa7b60b4aca021b0d8d1fed11ab8.jpeg",
    "https://cdn.faire.com/fastly/1ffb15af96f40e8c8b4b15f098a153ed8051d719495c8180b47969467a2a05aa.jpeg",
  ],
  priceDollars: 2,
  description:
    "You’ll get 24 shower steamers for this price. We have reduced plastic drastically by not having the shower steamers individually wrapped.\nPlease look at the last picture to see an example of how to shower steamers are shrink-wrapped.\n\n𝐓𝐨 𝐔𝐬𝐞:\nTurn your shower into a spa by using one of our shower steamers. Lay this tablet on the bottom floor of your shower and turn your water to its hottest setting while closing the door of your bathroom. Allow the tablet to dissolve halfway before entering the shower. Do not put the shower steamer directly into the water stream because it needs steam in order to dissolve the proper way.\n\nThis would make the perfect gift for anyone, or even bridal shower favors as well. You will get to select your scent at check out. Our variety set includes random fragrances that we have in stock at the moment.\n\n𝐈𝐧𝐠𝐫𝐞𝐝𝐢𝐞𝐧𝐭𝐬:\nbaking soda, citrus acid, cornstarch, distilled water, fragrance oils, Epsom salt, Almond oil\nMade in the United States of America",
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:19.916Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
